// components
import MNPGV2 from "./MNPGV2";
// types
import { TMainPageLayoutV3 } from "../type";


const MNPG069 = ( props: TMainPageLayoutV3 ) => {
    console.log("MNPG069.rendered: ", props);

    if ( !props.template ) return null;

    return (
        <div className="header-right d-flex justify-content-end align-items-center">
            <MNPGV2 templates={props.templates} mapLayoutName={props.template.mapLayoutName} parentId={props.template.id} />
        </div>
    )
}

export default MNPG069;
